import { ComponentPropsWithoutRef } from 'react';
import { FieldError } from 'react-hook-form';
import { FieldMessage } from '@/shared/ui/field-message';
import { FormFieldState } from './types';

type Props = {
    state: FormFieldState;
    error?: FieldError;
    messageWrapperProps?: ComponentPropsWithoutRef<typeof FieldMessage.Wrapper>;
};
export const FormFieldMessage = ({ state, error, messageWrapperProps }: Props) => {
    if (!error?.message) {
        return null;
    }

    return (
        <FieldMessage.Wrapper {...messageWrapperProps}>
            {state === 'error' && error?.message && (
                <FieldMessage state="error">{error.message}</FieldMessage>
            )}
        </FieldMessage.Wrapper>
    );
};
